import { PermissionTypes } from '@/constants/permissions'
import { useAppRole } from '@/hooks/useAppRole'
import { usePermission } from '@/hooks/usePermission'
import { Navigate } from 'react-router-dom'

type Props = {
	children: React.ReactNode
}

const CampaignGuard = ({ children }: Props) => {
	const { userHasPermission } = usePermission()
	const { isSuperAdmin } = useAppRole()

	if (!isSuperAdmin || !userHasPermission(PermissionTypes.Permissions_Campaigns_View)) {
		return <Navigate to="/access-denied" replace />
	}

	return <>{children}</>
}

export default CampaignGuard
